// Explore-stats page: List of all women in Parliament.
// Recreates the Handbook page — a Gantt timeline of every woman's service
// span (colour = party), filterable by chamber, with a supporting table.

import React, { useState, useEffect } from 'react';
import { Paper, Typography, Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import GanttTimeline from './GanttTimeline';

export default function WomenInParliament() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [chamber, setChamber] = useState('all');

  useEffect(() => {
    let active = true;
    setLoading(true);
    (async () => {
      try {
        const res = await getExploreStat('women-in-parliament',
          chamber === 'all' ? {} : { chamber });
        if (active) { setData(res); setError(null); }
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [chamber]);

  const charts = data?.charts || {};

  return (
    <ExploreStatsPage
      title="List of all women in Parliament"
      description={`Every woman who has served in the Australian Parliament, shown on a timeline by service span${
        charts.total ? ` (${charts.total})` : ''
      }. Note the low number of women in the early decades after the first were elected in 1943.`}
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="women-in-parliament"
    >
      <Box sx={{ mb: 2 }}>
        <ToggleButtonGroup size="small" exclusive value={chamber}
                           onChange={(e, v) => v && setChamber(v)}>
          <ToggleButton value="all">All</ToggleButton>
          <ToggleButton value="members">Members</ToggleButton>
          <ToggleButton value="senators">Senators</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {data && (
        <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>Women in Parliament over time</Typography>
          <GanttTimeline items={charts.timeline || []} />
        </Paper>
      )}
    </ExploreStatsPage>
  );
}
